export const IDLE = 'idle';
export const INCALL = 'inCall';
export const RINGING = 'ringing';
export const OUTGOING = 'outgoing';
export const OUTCALL = 'outCall';
